/* Silences all console logging globally (development and production) */
['log', 'debug', 'info', 'warn', 'error'].forEach((method) => {
  // eslint-disable-next-line no-console
  console[method] = () => {};
}); 